function createElement(tagName, className) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  return element;
}

function setContent(element, message, allowHtml) {
  if (allowHtml) {
    element.innerHTML = message;
  } else {
    element.textContent = message;
  }
}

function openDialog(message, options = {}, type = 'alert') {
  return new Promise((resolve, reject) => {
    const overlay = createElement('div', 'dg-backdrop dg-backdrop--local');
    const dialog = createElement('div', 'dg-container dg-container--local');
    const content = createElement('div', 'dg-content');
    const messageElement = createElement('div', 'dg-content-body');
    const actions = createElement('div', 'dg-content-footer');
    const okButton = createElement('button', 'dg-btn dg-btn--ok');
    const cancelButton = createElement('button', 'dg-btn dg-btn--cancel');

    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    const close = (accepted) => {
      overlay.removeEventListener('click', onBackdropClick);
      window.removeEventListener('keydown', onKeydown);
      overlay.remove();

      if (accepted) {
        resolve(true);
      } else {
        reject(new Error('Dialog cancelled'));
      }
    };

    const onBackdropClick = (event) => {
      if (event.target !== overlay || !options.backdropClose) return;
      close(type === 'alert');
    };

    const onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      if (type === 'alert') {
        close(true);
      } else {
        close(false);
      }
    };

    setContent(messageElement, message, options.html);
    okButton.type = 'button';
    okButton.textContent = options.okText || 'OK';
    okButton.addEventListener('click', () => close(true));

    actions.appendChild(okButton);

    if (type === 'confirm') {
      cancelButton.type = 'button';
      cancelButton.textContent = options.cancelText || 'Cancel';
      cancelButton.addEventListener('click', () => close(false));
      actions.insertBefore(cancelButton, okButton);
    }

    content.appendChild(messageElement);
    content.appendChild(actions);
    dialog.appendChild(content);
    overlay.appendChild(dialog);
    overlay.addEventListener('click', onBackdropClick);
    window.addEventListener('keydown', onKeydown);
    document.body.appendChild(overlay);
    okButton.focus();
  });
}

function installStyles() {
  if (document.getElementById('local-dialog-styles')) return;

  const style = document.createElement('style');
  style.id = 'local-dialog-styles';
  style.textContent = `
	    .dg-backdrop--local {
	      position: fixed;
	      inset: 0;
	      z-index: 1000000;
      display: flex;
      align-items: center;
	      justify-content: center;
	      padding: 1rem;
	      background: rgba(var(--background-numbers, 0, 0, 0), 0.72);
	      backdrop-filter: blur(0.2rem);
	    }

	    .dg-container--local {
	      width: calc(98% - 30px);
	      max-width: 420px;
	      margin: 25px auto;
	    }

	    .dg-content {
	      overflow: hidden;
	      text-align: center;
	      border-radius: 1rem;
	      border: 0.2rem solid var(--primary, rgb(0, 179, 164));
	      background: var(--background-transparent, rgba(0, 0, 0, 0.78));
	      box-shadow: 0 1px 9px 3px rgba(0, 0, 0, 0.57);
	      color: var(--secondary, #fff);
	      font-family: "Open Sans", sans-serif;
	      font-size: 1.05rem;
	      backdrop-filter: blur(0.3rem);
	    }

	    .dg-content-body {
	      padding: 1.5rem 1.5rem 0;
	      line-height: 1.5;
	      word-break: break-word;
	      border-bottom: 0;
	    }

	    .dg-content-footer {
	      display: flex;
	      align-content: center;
	      justify-content: center;
	      gap: 2rem;
	      padding: 1rem 1.5rem 1.5rem;
	      border-top: 0;
	      background: transparent;
	    }

	    .dg-btn {
	      min-width: 88px;
	      margin-top: 1rem;
	      margin-bottom: 1rem;
	      border: 1px solid var(--secondary, #fff);
	      border-radius: 2rem;
	      padding: 1rem 2rem;
	      background: transparent;
	      color: var(--secondary, #fff);
	      font-size: 1.15rem;
	      font-weight: 400;
	      line-height: 1.5;
	      cursor: pointer;
	      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
	        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	    }

	    .dg-btn--ok {
	      border-color: var(--primary, rgb(0, 179, 164));
	      background: var(--primary, rgb(0, 179, 164));
	      color: var(--secondary, #fff);
	    }

	    .dg-btn--cancel {
	      border-color: var(--secondary, #fff);
	      background: transparent;
	      color: var(--secondary, #fff);
	    }

	    .dg-btn:hover,
	    .dg-btn:focus {
	      color: var(--secondary, #fff);
	      background-color: var(--primary-darker, rgb(0, 147, 132));
	      border-color: var(--primary-darker, rgb(0, 147, 132));
	      box-shadow: 0 0 10px 0 var(--primary-darker, rgb(0, 147, 132));
	      outline: 0;
	    }

	    .dg-btn--ok:hover,
	    .dg-btn--ok:focus {
	      background-color: var(--primary-darker, rgb(0, 147, 132));
	      border-color: var(--primary-darker, rgb(0, 147, 132));
	    }

	    @media (max-width: 400px) {
	      .dg-content-footer {
	        flex-direction: column;
	        gap: 0;
	      }
	    }
	  `;
  document.head.appendChild(style);
}

export default {
  install(app) {
    installStyles();

    app.config.globalProperties.$dialog = {
      alert(message, options = {}) {
        return openDialog(message, options, 'alert');
      },
      confirm(message, options = {}) {
        return openDialog(message, options, 'confirm');
      },
    };
  },
};
